import {post} from './httpBase';
//账单页面
export function getBill(params) {
    return post('/order/shuntorder/getbills', params)
}
//交易列表
export function billList(params) {
    return post('/order/shuntorder/getbillsdetais', params)
}
//筛选
export function selectBill(params) {
    return post('/order/shuntorder/getbillsdetaisinorout', params)
}
//交易明细
export function billDetail(params) {
    return post('/order/shuntorder/getbillsdetaisbyone', params)
}


// WEBPACK FOOTER //
// ./src/service/waterBillService.js